// components/ui/separator.tsx

import React from "react";
import { cn } from "@/lib/utils";

interface SeparatorProps {
  className?: string;
}

export default function Separator({ className }: SeparatorProps) {
  return (
    <div className={cn(
      "border-t [border-image:linear-gradient(to_right,transparent,theme(colors.slate.400/.25),transparent)1]",
      className
    )}>
    </div>
  );
}